import type { NoiseFunction3D } from "simplex-noise";
import type { GameConfig } from "../config/GameConfig";

export class UpperAtmosphere {
  constructor(
    private readonly config: GameConfig,
    private readonly noise: NoiseFunction3D,
  ) {}

  sample(x: number, y: number, time: number): { x: number; y: number } {
    const w = this.config.wind;
    const t = time * w.noiseSpeed;
    const nx = this.noise(x * w.noiseScale, y * w.noiseScale, t);
    const ny = this.noise(x * w.noiseScale + 40, y * w.noiseScale + 11, t + 8);
    const swirl = this.noise(x * w.noiseScale * 0.45, y * w.noiseScale * 0.45, t * 0.5);
    return {
      x: (nx * w.turbulence + swirl * 0.35) * w.strength * w.lateralBias,
      y: ny * w.strength * w.verticalBias,
    };
  }
}
